export const NAPLAN_TEST_PACKS = [
  { label: 'NAPLAN Year 3 Test Pack', grades: ['Year 2', 'Year 3'] },
  { label: 'NAPLAN Year 5 Test Pack', grades: ['Year 4', 'Year 5'] },
  { label: 'NAPLAN Year 7 Test Pack', grades: ['Year 6', 'Year 7'] },
];

export const naplanTestPackLabels = NAPLAN_TEST_PACKS.map(pack => pack.label);
export const naplanTestPackGradesByCourse: Record<string, string[]> = Object.fromEntries(
  NAPLAN_TEST_PACKS.map(pack => [pack.label, pack.grades]),
);

export const getNaplanTestPackForGrade = (grade?: string) =>
  NAPLAN_TEST_PACKS.find(pack => pack.grades.some(value => value === grade))?.label;

export const isNaplanTestPack = (course?: string) =>
  NAPLAN_TEST_PACKS.some(pack => pack.label === course);

export const filterNaplanTestPacksForGrade = (courses: string[], grade?: string) =>
  courses.filter(course => !isNaplanTestPack(course) || course === getNaplanTestPackForGrade(grade));

export const clearMismatchedNaplanTestPack = (course: string | undefined, grade: string) =>
  isNaplanTestPack(course) && course !== getNaplanTestPackForGrade(grade) ? '' : course;

export const getQuickBookGrades = (
  course: string,
  gradesByCourse: Record<string, string[]> | undefined,
  eligibleGrades: string[],
) => isNaplanTestPack(course)
  ? naplanTestPackGradesByCourse[course] ?? []
  : gradesByCourse?.[course] ?? eligibleGrades;